.app {
  display: grid;
  grid-template-columns: 248px minmax(0, 1fr);
  min-height: 100vh;
}

.side {
  position: sticky;
  top: 0;
  height: 100vh;
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px 16px;
  border-right: 1px solid var(--line);
  background: color-mix(in srgb, var(--bg-raised) 72%, transparent);
}

.brand {
  display: grid;
  gap: 6px;
  padding: 0 8px;
  color: var(--accent);
}

.brandSub {
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 0.24em;
  text-transform: uppercase;
  color: var(--muted);
}

.nav {
  display: grid;
  gap: 18px;
  align-content: start;
}

.group {
  display: grid;
  gap: 4px;
}

.groupTitle {
  padding: 0 12px 4px;
  font-size: 11px;
  font-weight: 400;
  letter-spacing: 0.24em;
  text-transform: uppercase;
  color: var(--muted-dim);
}

.link {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 12px;
  border-radius: var(--radius-field);
  color: var(--muted);
  font-weight: 400;
  transition:
    background-color 0.2s ease,
    color 0.2s ease;
}

.link:hover {
  color: var(--text);
  background: var(--pill-bg);
}

.link[aria-current='page'] {
  color: var(--text);
  background: var(--pill-bg);
  box-shadow: inset 0 0 0 1px var(--pill-line);
}

.link:focus-visible,
.logout:focus-visible,
.brand:focus-visible {
  outline: 2px solid var(--accent);
  outline-offset: 2px;
}

.footer {
  margin-top: auto;
  display: grid;
  gap: 14px;
  justify-items: start;
}

.who {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  font-size: 13px;
}

.avatar {
  flex: none;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  border: 1px solid var(--line);
  background: var(--surface);
  color: var(--accent);
  font-family: var(--font-display);
  font-size: 14px;
}

.whoText {
  display: grid;
  min-width: 0;
}

.whoName {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.whoRole {
  color: var(--muted);
  font-size: 12px;
}

.logout {
  margin-left: auto;
  padding: 6px 10px;
  border-radius: 999px;
  background: transparent;
  color: var(--muted);
  font-size: 13px;
}

.logout:hover {
  color: var(--text);
  background: var(--pill-bg);
}

.main {
  min-width: 0;
  padding: 32px clamp(16px, 4vw, 48px) 64px;
}

.main > * {
  max-width: 1120px;
}

.guest {
  min-height: 100vh;
  display: grid;
  align-content: start;
  justify-items: center;
  gap: 24px;
  padding: 64px 16px;
}

.guestBrand {
  color: var(--accent);
}

.guestMain {
  width: 100%;
  max-width: 440px;
}

@media (max-width: 760px) {
  .app {
    grid-template-columns: minmax(0, 1fr);
  }

  .side {
    position: static;
    height: auto;
    gap: 12px;
    padding: 14px 16px;
    border-right: 0;
    border-bottom: 1px solid var(--line);
  }

  .nav {
    display: flex;
    gap: 4px;
    overflow-x: auto;
  }

  .group {
    display: flex;
  }

  .groupTitle {
    display: none;
  }

  .link {
    white-space: nowrap;
  }

  .footer {
    grid-auto-flow: column;
    align-items: center;
    margin-top: 0;
  }

  .main {
    padding-top: 20px;
  }
}

.count {
  margin-left: auto;
  min-width: 20px;
  padding: 0 7px;
  border-radius: 999px;
  background: var(--fill);
  background-image: var(--fill-gradient);
  color: var(--on-fill);
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  font-variant-numeric: tabular-nums;
}
